import { render, staticRenderFns } from "./BtnLoader.vue?vue&type=template&id=21e7a9ac&scoped=true&"
import script from "./BtnLoader.vue?vue&type=script&lang=js&"
export * from "./BtnLoader.vue?vue&type=script&lang=js&"
import style0 from "./BtnLoader.vue?vue&type=style&index=0&id=21e7a9ac&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e7a9ac",
  null
  
)

export default component.exports